import { render } from "./OrderInvoice.vue?vue&type=template&id=dc6c869e"
import script from "./OrderInvoice.vue?vue&type=script&lang=js"
export * from "./OrderInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__